import { createSlice } from "@reduxjs/toolkit";

const initialProductsState = {
  totalCount: 0,
  entities: null,
  lastError: null,
  listLoading: false,
  actionsLoading: false,
  selectedLicence: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const licencesSlice = createSlice({
  name: "licences",
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    setLicenses : (state, action) => {
      const { items, totalItems } = action.payload.data;
      state.entities = items || null;
      state.totalCount = totalItems || 0;
      state.listLoading = false;
    },
    setSelectedLicense: (state, action) => {
      state.selectedLicence = action.payload?.data;
      state.actionsLoading = false;
    },
  },
});
